const addApi = (name: string, fn: Function) => {
  window.IA_REACT_CORE_API = window.IA_REACT_CORE_API || {};
  window.IA_REACT_CORE_API[name] = fn;
};

export default addApi;
